import React, { useEffect, useState } from "react";
import { isBeta } from "../../../../../AdminConfig";
import {
  encodeBase64,
  GetSplitMyPartyAccInfo,
} from "../../../../../Api/ApiCommon";
import { useApi } from "../../../../../hooks/useApi";
import LineBtn from "../../../../Button/LineBtn";
import Loader from "../../../../DefaultStyles/Loader";
import { IPartyDetailMemberInfo } from "../PartyDetailMemberInfo";

interface AgreeHistoryBtnProps {
  d: IPartyDetailMemberInfo;
  data?: {
    enddate?: string;
    startdate?: string;
    maxmemb?: number;
    members?: number;
    owner?: string;
    partyid?: string;
    servsubsid?: number;
    parentPid?: number;
    sset_value?: number;
    ownerPayday?: number;
  };
}

export default function AgreeHistoryBtn({ d, data }: AgreeHistoryBtnProps) {
  const [btnClick, setBtnClick] = useState(false);
  const [sendPrevData, setSendPrevData] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    nickname: "",
    payday: 0,
    uid: 0,
    birth: "",
  });
  const [agreeHistory, setAgreeHistory] = useState({
    isPartyOwner: false,
    isSunrise: false,
  });

  const { response: prevResponse, loading: prevLoading } = useApi({
    method: "post",
    url: sendPrevData ? `party/light` : undefined,
    data: {
      uid: userData?.uid,
      partyid: data?.parentPid ?? 0,
    },
  });

  const agList = GetSplitMyPartyAccInfo(d?.shareid ?? "")?.agList ?? [];

  let party = {
    enddate: data?.enddate,
    startdate: data?.startdate,
    grade: d?.grade,
    joindate: d?.joindate,
    jointime: d?.jointime,
    maxmemb: data?.maxmemb,
    members: data?.members,
    ownerid: +data?.owner!,
    partyid: Number(data?.partyid),
    servsubsid: data?.servsubsid,
    parentpid: data?.parentPid ?? 0, // sunset pid
    deposit: d?.deposit ?? 0,
    ownerPayday: data?.ownerPayday ?? 0,
  };

  useEffect(() => {
    let obj = {
      admin: 1,
      userData,
      partyInfoData: {
        agList,
        party,
      },
    };

    let encoded = encodeBase64(JSON.stringify(obj));

    if (prevResponse && prevResponse?.status === 201) {
      const prevPartyData = {
        enddate: prevResponse?.data?.enddate ?? "",
        joindate: prevResponse?.data?.joindate ?? "",
        jointime: prevResponse?.data?.jointime ?? "",
        maxmemb: prevResponse?.data?.maxmemb ?? "",
        members: prevResponse?.data?.members ?? "",
        startdate: prevResponse?.data?.startdate ?? "",
      };

      const prevSubId = prevResponse?.data?.servsubsid ?? 0;
      const prevAgList =
        GetSplitMyPartyAccInfo(prevResponse?.data?.shareid)?.agList ?? [];

      console.log("❤️", prevAgList);

      setTimeout(() => {
        window.open(
          (isBeta ? `httsp://beta.linkid.pw/` : `https://linkid.pw/`) +
            `agree-history/list?info=${encoded}&isOwner=${Number(
              agreeHistory?.isPartyOwner
            )}&isSunrise=${Number(
              agreeHistory?.isSunrise
            )}&prevAgList=${prevAgList}&prevSubId=${prevSubId}&prevPartyData=${encodeBase64(
              JSON.stringify(prevPartyData)
            )}`
        );
      }, 500);

      setAgreeHistory({
        isPartyOwner: false,
        isSunrise: false,
      });

      setBtnClick(false);
    }
  }, [prevResponse]);

  useEffect(() => {
    if (btnClick) {
      let obj = {
        admin: 1,
        userData,
        partyInfoData: {
          agList,
          party,
        },
      };

      let encoded = encodeBase64(JSON.stringify(obj));

      setTimeout(() => {
        window.open(
          (isBeta ? `https://beta.linkid.pw/` : `https://linkid.pw/`) +
            `agree-history/list?info=${encoded}&isOwner=${Number(
              agreeHistory?.isPartyOwner
            )}&isSunrise=${false}&isAdmin=true`
        );
      }, 500);

      setAgreeHistory({
        isPartyOwner: false,
        isSunrise: false,
      });

      setBtnClick(false);
    }
  }, [btnClick]);

  return (
    <>
      <LineBtn
        icon="card_travel"
        btnClickEvent={() => {
          const isSunrise = data?.sset_value! < 0;

          setUserData({
            name: d?.name,
            nickname: d?.nickname,
            payday: d?.payday,
            uid: +d?.uid,
            birth: d?.birthday,
          });

          setAgreeHistory({
            isPartyOwner: d?.grade === 0 ? true : false,
            isSunrise,
          });

          // 연장 가입 멤버만 /light 보내기
          if (data?.parentPid! > 0 && isSunrise && d?.isOld) {
            setTimeout(() => {
              setSendPrevData(true);
            }, 500);
          } else {
            setBtnClick(true);
          }
        }}
        sPadding="0 7px"
      />

      {prevLoading && <Loader />}
    </>
  );
}
